import React from 'react';
import { makeStyles } from 'design-system/styles';

const LinkedAnnotationSelectorItem = (props: {
  id: string;
  label: string;
  color: string;
  isSelected: boolean;
  handleSelect: () => void;
}) => {
  const { id, label, color, isSelected, handleSelect } = props;

  const classes = makeStyles(theme => ({
    wrapper: {
      padding: '4px',
      margin: '4px 0',
      background: isSelected ? theme.colors.gray05 : undefined,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover': {
        background: isSelected ? theme.colors.gray05 : theme.colors.gray01,
      },
    },
    icon: {
      flexGrow: 0,
      flexShrink: 0,
      marginRight: '8px',
      width: '16px',
      height: '16px',
      borderRadius: '4px',
    },
    label: {
      fontWeight: 500,
    },
    id: {
      fontWeight: 400,
      fontFamily: 'monospace',
    },
  }))();

  return (
    <div className={classes.wrapper} onClick={handleSelect}>
      <div className={classes.icon} style={{ background: color }} />
      <div className={classes.label}>
        {label} <span className={classes.id}>{id.slice(-4)}</span>
      </div>
    </div>
  );
};

export default LinkedAnnotationSelectorItem;
